/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in page ra001500v
 * @created at      :   2022/05/18
 * @created by      :   ANS874 – quanhvm@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import repository from './repository';

export default {
    namespaced: true,
    state: {
        condition: {
            search: ''
        },
        resultSearch: []
    },
    mutations: {
        updateResultSearch(state, data) {
            if (data) {
                let list = [];
                const length = data.length;
                for (let i = 0; i < length; i++) {
                    list.push({
                        clientcode: data[i].clientcode,
                        shitaukecode: data[i].shitaukecode,
                        shitaukename: data[i].shitaukename,
                        shitaukenameEdit: data[i].shitaukename,
                        isEdit: false
                    });
                }
                state.resultSearch = list;
            }
            // console.log(state.resultSearch);
        },
        resetData(state) {
            state.resultSearch = [];
            state.condition.search = '';
        },
        updateDataEdit(state, data) {
            state.resultSearch[data.index].clientcode = data.clientcode;
            state.resultSearch[data.index].shitaukecode = data.shitaukecode;
            state.resultSearch[data.index].shitaukename = data.shitaukename;
            state.resultSearch[data.index].isEdit = false;
        },
        clearDataIndex(state, i) {
            state.resultSearch.splice(i, 1);
        }
    },
    actions: {
        /**
         * search data for screen
         * -----------------------------------------
         * @author : QuanHVM - 2022/05/18 - create
         * @params :
         * @access : private
         */
        search(context, condition) {
            try {
                repository.getAll(condition).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        context.commit('updateResultSearch', data.Data);
                    }
                });
            } catch (e) {
                console.log('Action search: ' + e.message);
            }
        },
        /**
         * clear data for screen
         * -----------------------------------------
         * @author : QuanHVM - 2022/06/07 - create
         * @params :
         * @access : private
         */
        clearScreen(context) {
            context.commit('resetData');
        },
        /**
         * edit data for screen
         * -----------------------------------------
         * @author : QuanHVM - 2022/06/07 - create
         * @params :
         * @access : private
         */
        edit(context, params) {
            try {
                repository.post(params).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        context.commit('updateDataEdit', params);
                    }
                });
            } catch (e) {
                console.log('Action search: ' + e.message);
            }
        },
        delete(context, params) {
            try {
                repository.delete(params.shitaukecode).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        context.commit('clearDataIndex', params.index);
                        this.dispatch(
                            'ra201000v/search',
                            context.state.condition
                        );
                    }
                });
            } catch (e) {
                console.log('Action search: ' + e.message);
            }
        }
    }
};
